import { Grid } from '@mui/material';
import { SuptypeDPParamsDataProps } from './props';
import { useSubtypeDPData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const SubtypeDPData = (props: SuptypeDPParamsDataProps) => {
    const { formik } = useSubtypeDPData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    required
                    errors={formik.errors.name}
                    value={formik.values.name}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Tipo PQR"
                    name="nestedParent"
                    size="small"
                    required
                    errors={formik.values.nestedParent}
                    value={formik.values.nestedParent}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Medio"
                    name="parent"
                    size="small"
                    required
                    errors={formik.values.parent}
                    value={formik.values.parent}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="extra2"
                    size="small"
                    rows={3}
                    errors={formik.values.extra2}
                    value={formik.values.extra2}
                />
            </Grid>
        </Grid>
    );
};
